import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { getQueryKey } from '@feature/utils';

import * as api from './TravelSettingsApi';
import { TravelSettings, TravelSettingsRequest } from './TravelSettingsTypes';

export const travelSettingsKey = getQueryKey('travelSettings');

export function getTravelSettingsOptions(): UseSuspenseQueryOptions<TravelSettings> {
  return {
    queryKey: travelSettingsKey.as(['one']),
    queryFn: () => api.get(),
  };
}

export function isTravelSettingsStaleError(error: Error) {
  const code = isAxiosError(error) ? (error.response?.data?.type ?? error.response?.data?.message) : null;
  return code === 'TRAVEL_SETTINGS_STALE';
}

export function useTravelSettingsUpdate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: TravelSettingsRequest) => api.update(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: travelSettingsKey.root(),
      }),
  });
}
